"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestContextUpdate = exports.useRequestContextHeaders = exports.RequestContextProvider = exports.RequestContext = void 0;
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const fdr_lib_context_request_util_1 = require("@hotelplan/fdr.lib.context.request-util");
const fdr_lib_i18n_lang_config_1 = require("@hotelplan/fdr.lib.i18n.lang-config");
const request_context_utils_1 = require("./request-context.utils");
exports.RequestContext = react_1.default.createContext({
    headers: {
        language: fdr_lib_i18n_lang_config_1.languageDefault,
        device: fdr_lib_context_request_util_1.EDeviceType.Desktop,
    },
    updateHeaders: () => void 0,
});
function RequestContextProvider({ initialContext, children, }) {
    const [currentHeaders, setHeaders] = (0, react_1.useState)(initialContext);
    const [, { language }] = (0, next_i18next_1.useTranslation)();
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const ctx = (0, react_1.useMemo)(() => {
        const headers = (0, request_context_utils_1.syncDeviceAndLanguage)(currentHeaders, language, mobile);
        return {
            headers,
            // was used in useReqContextContext <- useAuthentication
            updateHeaders(nextCtx) {
                setHeaders(prevCtx => {
                    const compactPrev = (0, fdr_lib_context_request_util_1.compactHeaders)(prevCtx);
                    const compactNext = (0, fdr_lib_context_request_util_1.compactHeaders)(nextCtx);
                    // don't destruct if values are equal or next value is empty
                    return (0, request_context_utils_1.isShallowEqual)(compactPrev, compactNext) ||
                        compactNext.length === 0
                        ? prevCtx
                        : compactNext;
                });
            },
        };
    }, [currentHeaders, language, mobile]);
    return (react_1.default.createElement(exports.RequestContext.Provider, { value: ctx }, children));
}
exports.RequestContextProvider = RequestContextProvider;
function useRequestContextHeaders() {
    const { headers } = react_1.default.useContext(exports.RequestContext);
    return headers;
}
exports.useRequestContextHeaders = useRequestContextHeaders;
function useRequestContextUpdate() {
    const { updateHeaders } = react_1.default.useContext(exports.RequestContext);
    return updateHeaders;
}
exports.useRequestContextUpdate = useRequestContextUpdate;
//# sourceMappingURL=request-context.js.map